import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { t } from 'i18next'
import { SetStateAction, useContext } from 'react'
import ParentFormDataContext from '../../contexts/ParentFormDataContext'
import Button from '../button/Button'

export interface IErrMessageSummary {
    className?: string
    setShowConfirmation: React.Dispatch<SetStateAction<boolean>>
}

const ErrMessageSummary: React.FC<IErrMessageSummary> = ({
    setShowConfirmation
}) => {
    const { parentFormData, setParentFormData } = useContext(
        ParentFormDataContext
    )
    const quoteErrors = parentFormData.QuoteErrorMessages.map((error, index) => {
        return <p key={index} className='font text-sm font-serif p-1 text-red-700'>* {error}</p>
    })

    return (
        <div className='flex flex-col border border-red-600 bg-[#ffccba] p-5'>
            <div className='flex flex-row'>
                <div className='pr-3'>
                    <ExclamationCircleIcon className='text-red-600 h-8 w-8' />
                </div>
                <div className='flex-col'>
                    {quoteErrors}
                </div>
            </div>
            <div className='mx-auto'>
                <Button
                    className="bg-white w-72 h-12 hover:bg-opacity-60 font-bold shadow-md"
                    text={t('goBack')}
                    handleClick={() => {
                        setShowConfirmation(false)
                    }}
                    textColor="text-black"
                    textSize="text-xl"
                />
            </div>
        </div>


    )
}

export default ErrMessageSummary
